module.exports = __webpack_public_path__ + "static/media/cabins-economy.93e1e36b.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/FlightPage/img/cabins-economy.png
// module id = 996
// module chunks = 0